import Journey from '@/assets/icons/Journey.svg';
import { HStack } from '@/elements/layout';

export const OpenIconAndText = () => (
  <HStack alignItems='center' justifyContent='center'>
    <Journey width='36px' height='36px' />
    <span>Jump To</span>
  </HStack>
);
